import { ReportChartOption } from '../types/trip';

export const MessageEventMap = {
  GREEN_DRIVING_TYPE: 253,
  OVER_SPEEDING: 255,
};

export const EVENT_MESSAGE_IDS = [
  MessageEventMap.OVER_SPEEDING,
  MessageEventMap.GREEN_DRIVING_TYPE,
];

export const trimBeforeComma = /^[^,]+, /;

export const TRIP_REPORT_GENERATOR_FIELDS = [
  { id: 0, value: ReportChartOption.SPEED },
  { id: 1, value: ReportChartOption.TEMPERATURE },
  { id: 2, value: ReportChartOption.GPS_SIGNAL },
  { id: 3, value: ReportChartOption.GSM_SIGNAL },
  { id: 4, value: ReportChartOption.RELIEF },
  { id: 5, value: ReportChartOption.VOLTAGE },
];

export const PLAYER_SPEED_VARIATIONS = [1, 2, 4, 8, 16, 32, 64];

export const trimFirst3Commas = /^([^,]*,){2}\s*/;

export const EMPTY_ARRAY = [];
